import axios from 'axios';

const API = axios.create({
  baseURL:'https://washwave-backend-fs0c.onrender.com/api',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const registerCustomer = (data) => API.post('/auth/register/customer', data);
export const registerShop     = (data) => API.post('/auth/register/shop', data);
export const loginUser        = (data) => API.post('/auth/login', data);
export const getMe            = ()     => API.get('/auth/me');

// Shops
export const getMyShop      = ()           => API.get('/shops/my-shop');
export const updateShop     = (data)       => API.put('/shops/my-shop', data);
export const getNearbyShops = (lat, lng)   => API.get(`/shops/nearby?lat=${lat}&lng=${lng}`);
export const getAllShops     = ()           => API.get('/shops/all');
export const getShop        = (id)         => API.get(`/shops/${id}`);

// Orders
export const createOrder       = (data) => API.post('/orders/', data);
export const getMyOrders       = ()     => API.get('/orders/my-orders');
export const getShopRequests   = ()     => API.get('/orders/shop-requests');
export const getShopAccepted   = ()     => API.get('/orders/shop-accepted');
export const acceptOrder       = (id)   => API.post(`/orders/${id}/accept`);
export const updateOrderStatus = (id, status) => API.put(`/orders/${id}/status?status=${status}`);

// Ratings
export const addRating      = (data)   => API.post('/ratings/', data);
export const getShopRatings = (shopId) => API.get(`/ratings/shop/${shopId}`);

export default API;
